module.exports = __webpack_public_path__ + "img/figi-logo-icon.989ef0a3.png";